import { Component, Vue } from 'vue-property-decorator';
import WithRender from './relayeddeposits.html';
import config from "@/settings/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';
import moment from 'moment';

@WithRender
@Component({
  filters: {
    formateDate(value: string) {
      return moment(value).format('YYYY-MM-DD HH:mm A')
    }
  },
  components: {
    Loading,
  }
})
export default class RelayedDeposits extends Vue {
  isLoading = false;

  perPage = 100;
  currentPage = 1;
  selectedPage = 1;
  totalRecords = 0;
  totalAmount = 0;

  items = [];
  fields = [
    { key: "matchedLabel", label: "Agent", sortable: false },
    { key: "agentCode", label: "Agent Code", sortable: false },
    { key: "deposit", label: "Deposit", sortable: false },
    { key: "reference", label: "Reference", sortable: false },
    { key: "message", label: "Message", sortable: false },
    { key: "receivedAt", label: "Received On (device)", sortable: false },
    { key: "depositApprovedOn", label: "Deposited & Approved", sortable: false },
  ]

  mounted() {
    this.getDeposits();
  }

  handlePageClick() {
    if (this.currentPage === this.selectedPage)
      return;
    this.currentPage = this.selectedPage;
    this.getDeposits();
  }

  getDeposits(): void {
    this.isLoading = true;
    _axios.get(`${config.gateway}relay/deposits?currentPage=${this.currentPage}&pageSize=${this.perPage}`)
      .then(response => {
        this.items = response.data.objectList;
        this.totalRecords = response.data.totalRowCount;
        this.totalAmount = response.data.totalAmount;
      })
      .catch(err => {
        console.error(err);
        const status = (err.response && err.response.status) || '';
        const detail = (err.response && err.response.data) || err.message || '';
        alert(`Could not load relayed deposits: ${status} ${detail}`);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
